import environment from './environment'
import {
  ErrorPlaceholder,
  LoadingPlaceholder
} from '@eggplant/pattern-library'
import { QueryRenderer } from 'react-relay'
import type { Error } from '@eggplant/types'
import type {
  ReactElement,
  ReactNode
} from 'react'

interface Renderer {
  error: any
  props: any
}

type RenderChildren = (data: object) => ReactNode

const renderError = (error: Error) =>
  <ErrorPlaceholder
    status={(error.status || '').toString()}
    title={error.title || ''}
  >
    {error.detail}
  </ErrorPlaceholder>

const getRenderer = (renderChildren: RenderChildren) =>
  ({ error, props }: Renderer) => {
    if (error) return renderError(error)

    if (!props) return <LoadingPlaceholder />

    return renderChildren(props) as ReactElement
  }

interface Props {
  children: RenderChildren
  query: any
  variables: object
}

const GraphRequest = ({
  children: renderChildren,
  query,
  variables
}: Props) =>
  <QueryRenderer
    // @ts-expect-error // Outdated demo code
    environment={environment}
    query={query}
    render={getRenderer(renderChildren)}
    variables={variables}
  />

export default GraphRequest
